const loanSimulation = () => {
    const el = document.querySelector('.js-loan-simulation');
    if (!el) return;

    const price = parseFloat(el.dataset.price) || 0;
    let currentRate = parseFloat(el.dataset.defaultRate) || 0;
    let currentTerm = parseFloat(el.dataset.defaultTerm) || 35;
    let currentDown = parseFloat(el.dataset.defaultDown) || 0;

    const borrowingEl = el.querySelector('.js-loan-borrowing');
    const monthlyEl = el.querySelector('.js-loan-monthly');

    const calcMonthly = (borrowing, rate, term) => {
        if (borrowing <= 0 || rate <= 0) return 0;
        const r = rate / 12;
        const n = term * 12;
        const factor = Math.pow(1 + r, n);
        return borrowing * 10000 * r * factor / (factor - 1);
    };

    const update = () => {
        const borrowing = Math.max(0, price - currentDown);
        const monthlyYen = calcMonthly(borrowing, currentRate, currentTerm);
        const monthlyMan = Math.round(monthlyYen / 10000 * 10) / 10;

        if (borrowingEl) borrowingEl.textContent = borrowing.toLocaleString('ja-JP');
        if (monthlyEl) monthlyEl.textContent = monthlyMan.toFixed(1);
    };

    const bindGroup = (container, setter) => {
        const btns = container.querySelectorAll('.c-others-loan-simulation__bar-btn');
        btns.forEach(btn => {
            btn.addEventListener('click', () => {
                btns.forEach(b => { b.dataset.selected = 'false'; });
                btn.dataset.selected = 'true';
                setter(parseFloat(btn.dataset.value));
                update();
            });
        });
    };

    const rateGroup = el.querySelector('[data-type="rate"]');
    const termGroup = el.querySelector('[data-type="term"]');
    const downGroup = el.querySelector('[data-type="down"]');

    if (rateGroup) bindGroup(rateGroup, v => { currentRate = v; });
    if (termGroup) bindGroup(termGroup, v => { currentTerm = v; });
    if (downGroup) bindGroup(downGroup, v => { currentDown = v; });

    update();
};

export default loanSimulation;
